// extracted by mini-css-extract-plugin
export default {"icon_modal_box":"useAlertSuccessModal_icon_modal_box__ZUVfF","modal-content":"useAlertSuccessModal_modal-content__eWOw4"};